<template>
  <Chi_DefaultSection class="menu--section-chi_chinese_new_year" :menu="menu" :section="section"
                      :section-modifier="sectionModifier" menu-item-component="chi-chinese-new-year-item"
                      menu-item-tag-location="after_title" item-group-layout="single_column"
                      content-area-top-layout="full_width" content-area-bottom-layout="full_width"
                      :is-title-box-visible="false" :is-title-buffer-visible="true"
                      section-menu-type="chi-chinese-new-year-item">
    <template #sectionTitleImage>
      <img src="/library/images/menu/chinese-new-year-chi-logo.jpg" alt="Chinese New Year Menu"
           class="menu--section_title_image">
    </template>
    <template #beforeBottomContentArea>
      <img src="/library/images/menu/chinese-new-year-chi-seal.jpg" alt="Chinese New Year Menu"
           class="menu--section_title_image">
    </template>
  </Chi_DefaultSection>
</template>

<script lang="ts">
/**
 * Custom component for Bimini default menu sections.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 2.2.0
 * @copyright  Copyright (C) 2023-2026, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 * @changelog
 * 2026-02-17 (2.1.0) (jhoward)
 *   - Add new App\Library\Js\Components\Menu\Section\Chi_chineseNewYearSection.vue component for Chinese New Year section in Chi menus.
 *   - Implements custom template, props, and styles for the new section, including images and layout.
 *
 * 2026-07-20 (2.2.0) (jhoward)
 *   - Add App\Library\Js\Components\Menu\Section\Chi_chineseNewYearSection.vue for Chinese New Year menu sections in Chi.
 */

import {defineComponent, PropType} from "vue";
import {Menu, MenuSection} from "../defs";
import Chi_DefaultSection from "./Chi_defaultSection.vue";

export default defineComponent({
  components: {
    Chi_DefaultSection,
  },
  name: "Chi_chineseNewYearSection",
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
    sectionModifier: {
      type: String,
      default: ''
    },
  },
})
</script>

<style scoped>
.menu_switcher--container + .visual_menu--page .menu--section-chi_chinese_new_year:first-child {
  padding-top: 0;
  margin-top: 10rem;
}

.menu--section-chi_chinese_new_year {
  position: relative;
  background-image: url('/library/images/menu/chinese-new-year-chi-border-middle.jpg');
  background-size: 100% auto;
  background-repeat: repeat-y;
  margin-left: 1em;
  margin-right: 1em;
  margin-bottom: 1em;
}

@media (min-width: 1056px) {
  .menu--section-chi_chinese_new_year {
    margin-left: auto;
    margin-right: auto;
  }
}

.textual_menu--section.menu--section-chi_chinese_new_year {
  margin-top: 1em;
}

.textual_menu--section.menu--section-chi_chinese_new_year:deep(.menu--page_content-top p) {
  text-align: center;
}

.menu--section-chi_chinese_new_year::before,
.menu--section-chi_chinese_new_year::after {
  position: absolute;
  content: "";
  z-index: -1;
  top: 0;
  left: 0;
  width: 100%;
  height: 2em;
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: top center;
  background-image: url('/library/images/menu/chinese-new-year-chi-border-top.jpg');
}

.menu--section-chi_chinese_new_year::after {
  top: auto;
  bottom: 0;
  background-position: bottom center;
  background-image: url('/library/images/menu/chinese-new-year-chi-border-bottom.jpg');
}

.menu--section-chi_chinese_new_year:deep(.menu--section_title::before),
.menu--section-chi_chinese_new_year:deep(.menu--section_title::after),
.menu--section-chi_chinese_new_year:deep(.menu--section_title_box) {
  display: none;
}

.menu--section_title_image {
  width: 140px;
  height: auto;
  margin: 3em auto 0 auto;
}

.textual_menu--section .menu--section_title_image {
  display: block;
  margin-top: 1em;
  margin-bottom: 2em;
}

@media (max-width: 768px) {
  .textual_menu--section .menu--section_title_image {
    padding-top: 3em;
  }
}

.menu--section-chi_chinese_new_year:deep(.menu--section_title) {
  color: #c4161c;
  font-weight: normal;
}
</style>